export const FRIEND_LOAD_SUCCESS = 'friend/LOAD_SUCCESS';
export const FRIEND_EDIT_SUCCESS = 'friend/EDIT_SUCCESS';
export const FRIEND_CREATE_SUCCESS = 'friend/CREATE_SUCCESS';
export const FRIEND_DELETE_SUCCESS = 'friend/DELETE_SUCCESS';
export const SET_BUSY = 'friend/SET_BUSY';
export const UNSET_BUSY = 'friend/UNSET_BUSY';